// Sem tipo de transação o backend responde 400 (e o SQL sem NOT EXISTS listaria toda a base).
export const hasTransactionTypes = (filter?: { transactionTypes?: unknown }): boolean =>
  Array.isArray(filter?.transactionTypes) && filter.transactionTypes.length > 0

// O `enabled` do react-query v5 aceita função da query; a chave do useGetList é
// [resource, 'getList', { pagination, sort, filter, meta }]. Assim a listagem nem dispara o GET.
export const inactiveCustomersQueryOptions = {
  enabled: (query: { queryKey: readonly unknown[] }) =>
    hasTransactionTypes((query.queryKey[2] as { filter?: { transactionTypes?: unknown } } | undefined)?.filter),
}
